export class SolarRadiationFormatValueConverter {
	toView(solarRadiation: number) {
		if (isNaN(solarRadiation)) {
			return null;
		}
		return `${solarRadiation.toFixed(1)} W/m2`;
	}
}